<template>
    <div class="taskdetail" v-wechat-title="$route.meta.title = title()">
        <!--        <nut-navbar-->
        <!--                @on-click-back="back"-->
        <!--                :leftShow="true"-->
        <!--                :rightShow="false"-->
        <!--        >任务详情</nut-navbar>-->
        <van-tabs v-model="activeName" color="#409eff" @click="tabClick">
            <van-tab name="a" title="基本信息" class="baseMsgWrap" style="height:calc(100% - 0px);overflow-y: auto;">
                <van-row class="">
                    <van-col span="8">
                        <van-icon name="location-o"/>
                        任务名称
                    </van-col>
                    <van-col span="16">{{taskName}}</van-col>
                </van-row>
                <van-row class="">
                    <van-col span="8">
                        <van-icon name="location-o"/>
                        任务类型
                    </van-col>
                    <van-col span="16">{{taskType}}</van-col>
                </van-row>
                <van-row class="">
                    <van-col span="8">
                        <van-icon name="location-o"/>
                        播放模式
                    </van-col>
                    <van-col span="16">{{taskPlayMode}}</van-col>
                </van-row>
                <van-row class="">
                    <van-col span="8">
                        <van-icon name="location-o"/>
                        日期范围
                    </van-col>
                </van-row>
                <van-row class="row-col-3">
                    <van-col span="11">{{startData}}</van-col>
                    <van-col span="1"> ~</van-col>
                    <van-col span="12">{{endData}}</van-col>
                </van-row>
                <van-row class="">
                    <van-col span="8">
                        <van-icon name="location-o"/>
                        时间范围
                    </van-col>
                </van-row>
                <van-row class="row-col-3">
                    <van-col span="11">{{startTime}}</van-col>
                    <van-col span="1"> ~</van-col>
                    <van-col span="12">{{endTime}}</van-col>
                </van-row>
                <van-row class="">
                    <van-col span="8">
                        <van-icon name="location-o"/>
                        任务周期
                    </van-col>
                </van-row>
                <van-row class="weekliWrap">
                    <div class="weekli" :class="taskDetailData['etMon'] === 'false' ? '': 'active'">一</div>
                    <div class="weekli" :class="taskDetailData['etTue'] === 'false' ? '': 'active'">二</div>
                    <div class="weekli" :class="taskDetailData['etWed'] === 'false' ? '': 'active'">三</div>
                    <div class="weekli" :class="taskDetailData['etThur'] === 'false' ? '': 'active'">四</div>
                    <div class="weekli" :class="taskDetailData['etFri'] === 'false' ? '': 'active'">五</div>
                    <div class="weekli" :class="taskDetailData['etSat'] === 'false' ? '': 'active'">六</div>
                    <div class="weekli" :class="taskDetailData['etSun'] === 'false' ? '': 'active'">日</div>
                </van-row>
                <van-row style="border:none;margin-top:10px;float:right;">
                    <van-col>
                        <van-button type="info" size="small" class="float-r" @click="editBtn">编辑</van-button>
                    </van-col>
                    <van-col>
                        <van-button type="info" size="small" class="float-r margin-l-10" @click="sendBtn">发送
                        </van-button>
                    </van-col>
                </van-row>
            </van-tab>
            <van-tab name="b" title="节目信息">
                <div style="height:calc(100% - 0px);overflow-y: auto;">
                    <van-cell-group style="margin:10px;" v-for="(item,index) in pmList" :key="index">
                        <van-cell title="节目名称" :value="item.pmName"/>
                        <van-cell title="节目分辨率" :value="item.pmResolution"/>
                        <van-cell title="节目类型" :value="item.pmType == '1' ? '普通' : '互动' "/>
                        <van-cell title="屏幕类别" :value="item.displayPos == '1' ? '主屏' : '副屏'"/>
                        <van-cell title="编辑节目" is-link @click="goto(item)"/>
                    </van-cell-group>
                </div>
            </van-tab>
            <van-tab name="c" title="设备列表">
                <ul style="padding: 20px" v-if="deviceList.length !==0">
                    <li v-for="(it,i) in deviceList" :key="i"
                        style="height: 40px;line-height: 30px;border-bottom: 1px solid #d4d4d4">
                      <span style="height: 100%;display: flex;align-items:center;">
                        <img v-if="it.onlineState === '-1'" style="width: 20px;margin-right: 10px"
                             src="/static/images/icon_dev_disonline.png" alt="">
                        <img v-else style="width: 20px;margin-right: 10px" src="/static/images/icon_dev_online.png"
                             alt="">
                        {{it.clName}}
                      </span>
                    </li>
                </ul>
                <div v-else style=" height: 100px;
            width: 100%;
            text-align: center;
            line-height: 100px;
            color: #8c8c8c;">暂无数据
                </div>
            </van-tab>

        </van-tabs>

        <!--        设备列表---底部弹出---开始-->
        <van-action-sheet
                v-model=" isVisible1"
                :round="isRound"
        >
            <van-row style="height:40px;line-height:40px;border-bottom:1px solid #ddd;">
                <van-col :span="4">
                    <van-button
                            style="width:100%;background:none;color:#EE0A24;border:none;line-height:40px;height:40px;text-indent: -14px;"
                            @click="closeGroup" type="danger" size="small"
                    >取消
                    </van-button>
                </van-col>
                <van-col :span="16" style="text-align: center">设备列表</van-col>
                <van-col :span="4">
                    <van-button
                            style="width:100%;background:none;color:#1B89FA;border:none;line-height:40px;height:40px;text-indent: -14px;"
                            @click="confirmSend" type="info" size="small"
                    >确定
                    </van-button>
                </van-col>
            </van-row>
            <div style="" class="equirpGroupContent scroll">
                <!--                activeNames2展开的项的name,这里将index作为nme-->
                <van-collapse class="scroll-a" v-model="activeNames2" @change="onCollapseChange" accordion>
                    <van-collapse-item v-for="(item,index) in menuItems2" :key="index" :name="index" :title="item.name"
                                       icon="/static/images/etv-folder.png">
                        <!--                        select保存复选框的选中的-->
                        <van-checkbox-group v-model="select" @change="onCheckboxGroupChange"
                                            v-if="index === activeNames2">
                            <van-cell-group>
                                <van-cell
                                        v-for="(item2,index2) in data"
                                        :key="index2"
                                        :title="item2.name"
                                        value-class="value-class"
                                        clickable
                                        @click="toggle"
                                        style="position: relative;"
                                        :icon="item2.onlineState == '1' ? '/static/images/icon_dev_online.png' : '/static/images/icon_dev_disonline.png'"
                                >
                                    <van-checkbox :class="'checkboxes-'+index2" :name="item2.clId+'-'+item2.clNo"
                                                  shape="square"/>
                                </van-cell>
                            </van-cell-group>
                        </van-checkbox-group>
                    </van-collapse-item>
                </van-collapse>
            </div>
        </van-action-sheet>
        <!--        设备列表---底部弹出---结束-->
    </div>
</template>

<script>
  import qs from 'qs'
  import {mapState, mapActions} from 'vuex'
  import {Toast} from 'vant'

  // eslint-disable-next-line no-unused-vars
  let deviceList = []

  function recursionDevice(data) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].type === "folder" && data.length > 0) {
        recursionDevice(data[i].children)
      } else {
        deviceList.push(data[i])
      }

    }
  }

  export default {
    name: "taskdetail.vue",
    data() {
      return {
        activeName: 'a',
        taskId: '',
        taskName: '',
        taskType: '',
        taskPlayMode: '',
        taskDataRange: '',
        taskTimeRange: '',
        taskCycle: '',
        taskDetailData: {},
        pmList: [],
        startData: '',
        endData: '',
        startTime: '',
        endTime: '',
        menuItems2: '',
        isVisible1: false,
        activeNames2: '',
        select: [],
        isRound: false,
        index: 0,
        data: [],
        deviceList: []
      }
    },
    computed: {
      ...mapState({
        taskId1: state => state.taskId
      })
    },
    mounted() {
      this.taskId = this.$route.query.id
      this.getBaseInfo()
      this.getProMsg()
    },
    methods: {
      ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),

      tabClick(event) {
        if (event === "c") {
          this.$ajax.post('/etv/selectEqTaskBindClient.json', qs.stringify({
            id: this.taskId
          })).then(res => {
            deviceList.length = 0
            recursionDevice(res.data.data.children)
            this.deviceList = deviceList
          })
        }
      },

      getBaseInfo() {
        this.$ajax.post('/etv/selectEquipmentTaskById.json', qs.stringify({
          id: this.taskId
        })).then(res => {
          this.taskName = res.data.data.etName

          this.startData = res.data.data.etStartDate
          this.endData = res.data.data.etEndDate
          this.startTime = res.data.data.etStartTimett
          this.endTime = res.data.data.etEndTime

          this.taskDataRange = res.data.data.etStartDate + '~' + res.data.data.etEndDate
          this.taskTimeRange = res.data.data.etStartTime + '~' + res.data.data.etEndTime
          switch (res.data.data.etTaskType) {
            case '1':
              this.taskType = '普通任务'
              break
            case '2':
              this.taskType = '双屏异显'
              break
            case '3':
              this.taskType = '互动任务'
              break
            case '4':
              this.taskType = '同步任务'
              break
          }
          this.taskPlayMode = res.data.data.etPlayMode == '1' ? '普通模式' : '追加模式'
          this.taskCycle = res.data.data.etName
          // _this.taskDetailData = res.data.data.join(",")
          this.taskDetailData = res.data.data

          this.pmList = res.data.data.pmList


        })
      },
      editBtn() {
        this.changeTopTitle('修改任务')
        this.setParentPage('taskdetail')
        this.$router.push({path: '/addTask', query: {data: this.taskDetailData, parentPage: 'taskdetail'}})
      },
      getProMsg() {
        // selectEquipmentTaskById
        // let _this = this
        // this.$ajax.post('/etv/selectEquipmentTaskById.json', qs.stringify({
        //     id: _this.taskId
        // })).then(res => {
        //     console.log(res)
        // })
      },
      sendBtn() {
        this.isVisible1 = true
        this.$ajax.post('/etv/selectSeachClientTreeMobile.json', qs.stringify({
          groupParentId: '',
          type: '',
          onlineState: '',
          clientName: '',
        })).then(res => {
          this.menuItems2 = res.data.data
          const Terminal = document.getElementsByClassName('scroll')[0]
          Terminal.addEventListener('scroll', this.handleScroll)
        })
      },
      closeGroup() {
        this.isVisible1 = false
        this.menuItems2 = []
      },
      confirmSend() {
        if (this.select.length == 0) {
          Toast('请选择设备')
          return
        }
        let _this = this
        let postData = {
          ceEtId: _this.taskId,
          clientNos: '',
          ids: '',
        }
        let equipArr = _this.select
        let clNoArr = [], clIdArr = []
        for (var i = 0; i < equipArr.length; i++) {
          clNoArr.push(equipArr[i].split('-')[1])
          clIdArr.push(equipArr[i].split('-')[0])
        }
        postData.clientNos = clNoArr.join(',')
        postData.ids = clIdArr.join(',')

        this.$ajax.post('/etv/insertClientEqTask.json', qs.stringify(postData)).then(res => {
          if (res.data.code == 0) {
            Toast('任务发送成功')
            _this.$emit('changeItemShow', 'c')
            // _this.$router.push({ path: '/programs', query: { itemName: 'c'} })
          } else {
            Toast(res.data.msg)
          }
          _this.isVisible1 = false
          _this.select = []
          _this.sendTaskId = ''

        })
      },
      onCollapseChange(activeNames2) {
        this.index = 0
        if (activeNames2 === '') {
          return
        }
        this.activeNames2 = activeNames2
        if (this.menuItems2[this.activeNames2].children.length > 0) {
          this.data = this.menuItems2[this.activeNames2].children.slice(this.index, 15)
        } else {
          this.data = []
        }
      },
      title() {
        switch (this.activeName) {
          case 'a':
            return '基本信息'
          case 'b':
            return '节目信息'
        }
      },
      onCheckboxGroupChange() {

      },
      toggle() {
      },
      handleScroll() {
        //滚动条
        const scrollHeight = document.getElementsByClassName('scroll')[0].scrollTop
        let clientHeight = document.getElementsByClassName('scroll-a')[0].clientHeight
        //真实高度
        if (clientHeight - 640 - scrollHeight < 40) {
          if (this.menuItems2[this.activeNames2].children.slice(this.index * 15, this.index * 15 + 15).length < 15) {
            return
          }
          this.index++
          this.data = [...this.data, ...this.menuItems2[this.activeNames2].children.slice(this.index * 15, this.index * 15 + 15)]
        }
      },
      goto(item) {
        this.$router.push({
          path: `/createProrram`,
          query: {
            id: item.id,
            type: 'edit'
          }
        })
      }
    }
  }
</script>

<style lang="scss">
    @import "../../public/static/css/app";

    .taskdetail {
        .van-cell__value {
            color: #323233;
        }

        .margin-l-10 {
            margin-left: 10px;
        }

        .equirpGroupContent {
            height: 25rem;
            overflow-y: auto;
            width: 100%;

            .van-collapse-item__content {
                padding: 0 16px;
            }

            .van-collapse-item__wrapper {
                position: relative;

                .van-cell {

                    .van-checkbox {
                        justify-content: flex-end;
                    }
                }
            }
        }

        .van-tab__pane {
            &.baseMsgWrap {
                padding: 0 20px;
            }

            .van-row {
                height: 40px;
                line-height: 40px;
                border-bottom: 1px solid #ebedf0;
                font-size: 14px;

                .van-col--8 {
                    color: #323233;
                }

                .van-col--16 {
                    text-align: right;
                    /*color:#969799;*/
                    color: #323233;
                }

                .van-icon-location-o:before {
                    content: '';
                }

                .van-icon-location-o {
                    margin: 4px 6px 0 0;
                    width: 16px;
                    height: 16px;
                    color: #1B89FA;
                    background: #1B89FA;
                    border-radius: 50%;
                    line-height: 10px;
                }

                &.row-col-3 {
                    .van-col {
                        display: flex;
                        justify-content: center;
                        /*color:#969799;*/
                        color: #323233;
                    }

                }

                &.weekliWrap {
                    display: flex;
                    justify-content: space-around;
                    height: 44px;

                    .weekli {
                        margin-top: 4px;
                        width: 32px;
                        height: 32px;
                        background: #fff;
                        border: 1px solid #1B89FA;
                        color: #1B89FA;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .weekli.active {
                        background: #1B89FA;
                        color: #fff;
                    }


                }

            }
        }


    }
</style>
